export default __webpack_public_path__ + "static/media/app-poster-hard-launch-aims.d0d578a1.jpg";